<template>
	<div
		class="w-1/3 p-6 bg-green-500 text-green-100 flex flex-col justify-center"
	>
		<!-- deprecated; now we use StartNotYetActivated.vue -->
		<div v-if="locale == 'de'">
			<h1>Danke für Ihre Anmeldung!</h1>
			Max wird Sie demnächst freischalten und dann kann es richtig losgehen!
		</div>
		<div v-else>
			<h1>Danke für Ihre Anmeldung!</h1>
			Max wird Sie demnächst freischalten und dann kann es richtig losgehen!
		</div>
	</div>
</template>

<script>
export default {};
</script>
